import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-brand-green text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-shadow w-full max-w-md mx-auto block text-center ${className}`} onClick={() => {
    window.open('https://soscalma.com/', '_blank');
  }} data-id="element-12">
      ¡SÍ, QUIERO MI REINICIO METABÓLICO AHORA!
    </motion.button>;
}